module.exports = __webpack_public_path__ + "static/media/icon.c8a8ffb5.png";